import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import VideoCard from '@/components/base/VideoCard';
import ArticleCard from '@/components/base/ArticleCard';
import { videos, categories } from '@/mocks/videos';
import { articles } from '@/mocks/articles';

const hotVideos = videos.filter((v) => v.isHot);
const newVideos = videos.filter((v) => v.isNew);
const featuredArticles = articles.filter((a) => a.isFeatured);

const faqs = [
  {
    q: '鲍鱼tv是什么？',
    a: '鲍鱼tv是一款领先的高清视频在线观看平台，提供海量影视、综艺、动漫、直播等多种类型内容，支持手机、平板、电脑、智能电视等多终端流畅播放，致力于为用户提供优质的视听娱乐体验。',
  },
  {
    q: '鲍鱼tv免费播放是真的吗？',
    a: '是的，鲍鱼tv提供大量免费高清内容供用户观看，包括热播综艺、精彩纪录片、经典影视剧集等。部分最新院线大片和独家内容可能需要会员权益，我们也会不定期推出免费观看活动。',
  },
  {
    q: '如何下载安装鲍鱼tv最新版？',
    a: '您可以访问鲍鱼tv官网，在下载页面根据您的设备选择对应的客户端版本。目前支持iOS、Android、Windows、macOS以及主流智能电视系统。安装过程简单快捷，只需按照提示操作即可完成。',
  },
  {
    q: '鲍鱼tv支持哪些播放设备？',
    a: '鲍鱼tv支持全平台播放，包括手机（iOS/Android）、平板电脑、个人电脑（Windows/macOS）、智能电视、电视盒子等。同一账号可在不同设备间无缝切换，观看记录和收藏自动同步。',
  },
  {
    q: '鲍鱼tv的视频画质如何？',
    a: '鲍鱼tv采用先进的视频编码技术，支持从流畅到4K超清的多档画质选择。系统会根据您的网络状况智能推荐最佳画质，确保流畅不卡顿的观看体验。',
  },
];

const stats = [
  { value: '5亿+', label: '累计用户' },
  { value: '10万+', label: '影片资源' },
  { value: '99.9%', label: '服务可用率' },
  { value: '4K', label: '超清画质' },
];

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '鲍鱼tv - 高清视频在线观看平台',
    description:
      '鲍鱼tv是一款提供海量高清视频内容的在线观看平台，涵盖影视、综艺、直播等多种类型内容，支持多终端流畅播放。',
    url: 'https://www.baoyutv.com/',
    isPartOf: {
      '@type': 'WebSite',
      name: '鲍鱼tv',
      url: 'https://www.baoyutv.com/',
    },
    about: {
      '@type': 'Organization',
      name: '鲍鱼tv',
      description: '高清视频在线观看平台',
    },
  };

  const faqLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqLd)}</script>

      <main>
        <Navbar />

        {/* Hero Section */}
        <header className="relative w-full h-[600px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Modern%20streaming%20platform%20hero%20background%20with%20abstract%20geometric%20shapes%2C%20warm%20orange%20and%20amber%20gradient%20accents%2C%20cinematic%20atmosphere%2C%20floating%20film%20reels%20and%20play%20buttons%2C%20clean%20minimalist%20design%2C%20dark%20rich%20background%20with%20warm%20highlights&width=1920&height=600&seq=baoyu-hero&orientation=landscape"
            alt="鲍鱼tv - 高清视频在线观看平台"
            title="鲍鱼tv - 海量高清视频免费观看"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-4 max-w-3xl">
              海量高清视频，<span className="text-primary-400">随时随地</span>畅享精彩
            </h1>
            <p className="text-base md:text-lg text-background-200 max-w-2xl mb-8 leading-relaxed">
              鲍鱼tv汇聚影视、综艺、动漫、直播等海量内容，4K超清画质，多终端无缝切换，
              为你打造极致观影娱乐体验。立即加入5亿用户的选择！
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Link
                to="/category/all"
                className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all text-sm whitespace-nowrap"
              >
                立即观看
              </Link>
              <Link
                to="/about"
                className="px-8 py-3 bg-background-50/20 text-background-50 font-medium rounded-full hover:bg-background-50/30 transition-all text-sm backdrop-blur-sm whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </header>

        {/* Stats Bar */}
        <section className="w-full bg-background-50 border-b border-background-200/70 py-8">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500">
                    {stat.value}
                  </div>
                  <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Category Navigation */}
        <section className="w-full py-12 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
              内容分类
            </h2>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
                  className="flex flex-col items-center gap-2 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer group"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Hot Videos */}
        <section className="w-full py-12 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                <i className="ri-fire-line text-primary-500 mr-2"></i>
                热门推荐
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop="">
              {hotVideos.slice(0, 8).map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* New Arrivals */}
        <section className="w-full py-12 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                <i className="ri-sparkling-line text-accent-500 mr-2"></i>
                最新上线
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                查看全部 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-product-shop="">
              {newVideos.map((video) => (
                <VideoCard key={video.id} video={video} />
              ))}
            </div>
          </div>
        </section>

        {/* Featured Articles */}
        <section className="w-full py-12 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                <i className="ri-article-line text-secondary-500 mr-2"></i>
                最新资讯
              </h2>
              <Link
                to="/category/all"
                className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1"
              >
                更多文章 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full py-12 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqs.map((faq, index) => (
                <details
                  key={index}
                  className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
                >
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                    <span className="text-sm font-medium text-foreground-900 pr-4">
                      {faq.q}
                    </span>
                    <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="w-full py-16 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20gradient%20background%20with%20warm%20orange%20and%20deep%20amber%20tones%2C%20soft%20flowing%20shapes%2C%20film%20texture%20overlay%2C%20elegant%20minimalist%20design%2C%20clean%20dark%20base%20with%20luminous%20warm%20accents&width=1920&height=400&seq=baoyu-cta&orientation=landscape"
            alt=""
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/40"></div>
          <div className="relative z-10 max-w-3xl mx-auto text-center px-4">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              即刻开启你的<span className="text-primary-400">高清观影</span>之旅
            </h2>
            <p className="text-sm md:text-base text-background-200 mb-8 leading-relaxed">
              加入鲍鱼tv，畅享海量高清影视内容。新用户注册即可获得7天免费会员体验，
              感受4K超清画质带来的震撼视听享受。
            </p>
            <Link
              to="/category/all"
              className="inline-block px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all text-sm whitespace-nowrap"
            >
              免费开始使用
            </Link>
          </div>
        </section>

        <Footer />
      </main>
    </>
  );
}